import { ref } from 'vue';
import axios from 'axios';

const user = ref(null);

export const useAuth = () => {
    const getUser = async () => {
        const token = localStorage.getItem('token');
        if (!token) {
            user.value = null;
            return null;
        }

        const response = await axios.get('/api/auth/user', {
            headers: { Authorization: `Bearer ${token}` },
        });

        if (response.data.user) {
            user.value = response.data.user;
            return user.value;
        } else {
            localStorage.removeItem('token');
            user.value = null;
            return null;
        }
    };

    const login = async (email, password) => {
        const response = await axios.post('/api/auth/login', {
            email,
            password,
        });

        localStorage.setItem('token', response.data.token);
        user.value = response.data.user;
        return response.data;
    };

    const register = async (userData) => {
        const response = await axios.post('/api/auth/register', userData);
        return response.data;
    };

    const logout = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.post('/api/logout', {}, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            localStorage.removeItem('token');
            user.value = null;

            return response.data;
        } catch (error) {
            console.error(error);
        }
    };

    const verifyEmail = async (verificationCode, email) => {
        const response = await axios.post('/api/auth/verify-email', { verification_code: verificationCode, email });

        localStorage.setItem('token', response.data.token);
        user.value = response.data.user;

        return response.data;
    };

    const resendVerificationEmail = async (email) => {
        const response = await axios.post('/api/auth/resend-verification-email', { email });
        return response.data;
    };

    const forgotPassword = async (email) => {
        const response = await axios.post('/api/auth/forgot-password', { email });
        return response.data;
    };

    const resetPassword = async (email, token, password, password_confirmation) => {
        const response = await axios.post('/api/auth/reset-password', { email, token, password, password_confirmation });
        return response.data;
    };

    const isAuthenticated = () => !!user.value;

    return {
        user,
        getUser,
        login,
        register,
        logout,
        verifyEmail,
        resendVerificationEmail,
        forgotPassword,
        resetPassword,
        isAuthenticated,
    };
};
